$(document).ready(function() {
	// track repair signin 
	if(!document.querySelector('.track-repair-inquiry-area')) return false;
	
	// repair service Inquiry
	var rcIq = {
		el: $('.track-repair-inquiry-area.field-wrap form'), // form
		mobileForm: document.getElementById('trackRepairMobile'),
		init: function() {
			rcIq.addEvent();
		},
		beforeSubmit: function(e){
			e.preventDefault();
			var currentForm = e.currentTarget;
			
			/* LGCOMMON-6557 START */
			if( $("#useNewCaptcha").length > 0 && $("#useNewCaptcha").val() == "Y" && !!$('#siteKey').val() && $("#useNewCaptchaView").val() == "N"){
				var reCaptcha_Key = $('#siteKey').val();
		    	grecaptcha.enterprise.ready(function() {
		    		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageType").val()}).then(function(token) {
		    			$("#verifyKey").val(btoa(token));
		    			formSubmit();
		    		});
		    	});
			}
			
			function formSubmit(){
				/* LGEES-41 20200612 add */
				var country = $('html').data('countrycode');
				var $trackRepairPolicyAgree = $('#trackRepairPolicyAgree');
				var chkOtherValidation = (country === 'es' && currentForm.id === 'trackRepairInquirySecond' && $trackRepairPolicyAgree.length) ? $trackRepairPolicyAgree.checkValidation() : true;
				/* //LGEES-41 20200612 add */

				// ajax validation
				if($(currentForm).checkValidation() && chkOtherValidation) { /* LGEES-41 20200612 add */
					var $receiptNumber = $(currentForm).find('#receiptNumber');
					$receiptNumber.val( $.trim($receiptNumber.val()).toUpperCase() );
					var url = currentForm.getAttribute('data-url');
					var param = xssfilter($(currentForm).serialize());
					var methodType = $(currentForm).data('ajaxMethod');
					// number validation
					$('body').trigger('ajaxLoadBefore');
					ajax.call(url, param, 'json', function(data){
						$('body').trigger('ajaxLoadEnd');
						if(!data.result){
							var block = $(currentForm).find('.ajax-msg');
							$(currentForm).find('.field-block').addClass('error');
							if(data.msg) {
								block.text(data.msg);
							}
							block.show().siblings().hide();
						}else {
							if(data.flag && data.flag != null) {
								currentForm.flag.value = data.flag;
							}
							if(data.submitData && data.submitData != null) {
								// currentForm.flag.value = data.flag;
								if(!currentForm.submitData) {
									$(currentForm).append('<input type="hidden" name="submitData" value="">');
								}
								currentForm.submitData.value = JSON.stringify(data.submitData);
							}
							
							var reCaptcha_Key = $('#siteKey').val();
					    	grecaptcha.enterprise.ready(function() {
					    		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageType").val()}).then(function(token) {
					    			$("#verifyKey").val(btoa(token));
					    			$("#verifyKeyExtra").val(data.verifyKeyExtra);
					    			currentForm.submit();
					    		});
					    	});
						}
					}, methodType);
				}
			}
			/* LGCOMMON-6557 END */
		},
		addEvent: function(){
			rcIq.el.each(function(){
				$(this).on({
					submit: rcIq.beforeSubmit
				});
			});
			
			$(rcIq.mobileForm).on({
				submit: rcIq.beforeSubmit
			});
		}
	};

	rcIq.init();

	$(".accordion-wrap").on("click", ".link-text", function(){
		var $this = $(this);
		var $group = $this.closest(".accordion-group");
		if(!$group.hasClass("open")){
			$this.addClass("active");
			$group.addClass("open").find(".accordion-content").stop().slideDown();
		}else{
			$this.removeClass("active");
			$group.removeClass("open").find(".accordion-content").stop().slideUp();
		}
	});
});